import { Routes } from "../../../routes";
import {
  faChartPie,
  faPiggyBank,
  faMoneyBill,
  faUniversity,
  faFileContract,
  faFileInvoiceDollar,
  faLandmark,
  faHandHoldingUsd,
  faCoins,
  faExchangeAlt,
  faUserTie,
  faClipboardList,
  faClipboardCheck,
  faUserShield,
  faMoneyBillWave,
  faPaperPlane,
  faChartBar,
  faChartLine,
  faFileAlt,
  faBook,
  faWallet,
  faEye,
  faUsersCog,
} from "@fortawesome/free-solid-svg-icons";

export const mainTreasuryModules = [
  {
    title: "Dashboard",
    section: "Overview",
    route: Routes.DashboardOverview.path,
    icon: faChartPie,
  },
  {
    title: "TSA Funding",
    section: "Treasury Operations",
    route: Routes.tsafunding.faacTsaFunding,
    icon: faPiggyBank,
    subMenu: [
      {
        title: "FAAC TSA Funding",
        route: Routes.tsafunding.faacTsaFunding + "/FAAC TSA Funding",
      },
      {
        title: "JAAC TSA Funding",
        route: Routes.tsafunding.faacTsaFunding + "/JAAC TSA Funding",
      },
    ],
  },
  {
    title: "Budget",
    section: "Treasury Operations",
    route: Routes.budget.budgetUtlization,
    icon: faMoneyBill,
    subMenu: [
      {
        title: "Budget Utilization",
        route: Routes.budget.budgetUtlization,
      },
      {
        title: "Upload Budget",
        route: Routes.budget.uploadBudget,
      },
    ],
  },
  {
    title: "MDA Banks",
    section: "Treasury Operations",
    route: Routes.bank.bankIndex,
    icon: faUniversity,
  },
  {
    title: "Collection For Release",
    section: "Releases & Vouchers",
    route: Routes.approval.approvalIndex,
    icon: faFileContract,
    subMenu: [
      {
        title: "Pending Releases",
        route: Routes.approval.pendingApproval,
      },
      {
        title: "CC Copies",
        route: Routes.approval.mdaReleases,
      },
      {
        title: "Review Releases",
        route: Routes.approval.reviewReleases,
      },
      {
        title: "Approve Releases",
        route: Routes.approval.approvalReleases,
      },
      {
        title: "AG Releases Dashboard",
        route: Routes.approval.agApprovalDashboard,
      },
      {
        title: "AG Releases",
        route: Routes.approval.agReleases,
      },
      {
        title: "AG Approved Releases",
        route: Routes.approval.agApprovedReleases,
      },
      {
        title: "Auditor Releases Dashboard",
        route: Routes.approval.auditorGeneralApprovalDashboard,
      },
      {
        title: "AD Exp. Control Releases",
        route: Routes.approval.adExpContrReleases,
      },
      {
        title: "Release Tracking",
        route: Routes.approval.releaseTracking,
      },
      {
        title: "All Releases Tracking",
        route: Routes.approval.allReleasesAdmin,
      },
    ],
  },
  {
    title: "Payment Vouchers",
    section: "Releases & Vouchers",
    route: Routes.DashboardOverview,
    icon: faFileInvoiceDollar,
    subMenu: [
      {
        title: "Generate PV",
        route: Routes.pv.pvlIndex,
      },
      {
        title: "Check PV",
        route: Routes.pv.pvCheckIndex,
      },
      {
        title: "Review PV",
        route: Routes.pv.pvReviewIndex,
      },
      {
        title: "Approve PV",
        route: Routes.pv.pvApproveIndex,
      },
      {
        title: "Approve PV (AG Office)",
        route: Routes.pv.pvApproveIndex,
      },
      {
        title: "PV Status Tracking",
        route: Routes.pv.pvStatusTracking,
      },
      {
        title: "All PVs Tracking",
        route: Routes.pv.allPVsAdmin,
      },
      {
        title: "Auditor PV Dashboard",
        route: Routes.pv.auditorpvReports,
      },
      {
        title: "Contractor Management",
        route: Routes.contractorManagement.list,
      },
    ],
  },
  {
    title: "MDA Payment Vouchers",
    section: "Releases & Vouchers",
    route: Routes.DashboardOverview,
    icon: faLandmark,
    subMenu: [
      {
        title: "New PV",
        route: Routes.mdaPv.new,
      },
      {
        title: "Check PV",
        route: Routes.mdaPv.check,
      },
      {
        title: "Review PV",
        route: Routes.mdaPv.review,
      },
      {
        title: "Approve PV",
        route: Routes.mdaPv.approve,
      },
      {
        title: "Status Tracking",
        route: Routes.mdaPv.tracking,
      },
    ],
  },
  {
    title: "Cash Office",
    section: "Releases & Vouchers",
    route: Routes.DashboardOverview,
    icon: faHandHoldingUsd,
    subMenu: [
      {
        title: "Pending Payments",
        route: Routes.cashOffice.pending,
      },
      {
        title: "Review Payments",
        route: Routes.cashOffice.review,
      },
      {
        title: "Approve Payments",
        route: Routes.cashOffice.approve,
      },
    ],
  },
  {
    title: "Cash Backing",
    section: "Releases & Vouchers",
    route: Routes.DashboardOverview,
    icon: faCoins,
    subMenu: [
      {
        title: "Pending Cash Backing",
        route: Routes.cashBacking.cashBackinPending,
      },
    ],
  },
  {
    title: "Payments",
    section: "Releases & Vouchers",
    route: Routes.DashboardOverview,
    icon: faExchangeAlt,
    subMenu: [
      {
        title: "Approve Cash Backing",
        route: Routes.paymentRequest.approvePaymentRequest,
      },
      {
        title: "Direct Transfer",
        route: Routes.paymentRequest.directTransferList,
      },
    ],
  },
  {
    title: "Self Accounting MDA",
    section: "Releases & Vouchers",
    route: Routes.DashboardOverview,
    icon: faUserTie,
    subMenu: [
      {
        title: "Cash Backing Request",
        route: Routes.cashBacking.cashBackingRequest,
      },
    ],
  },
  {
    title: "Expenditure Control",
    section: "Expenditure Control",
    route: Routes.DashboardOverview,
    icon: faClipboardList,
    subMenu: [
      {
        title: "Receiving Office",
        route: Routes.expenditureControl.receivingOfficeIndex,
      },
      {
        title: "Expenditure Control",
        route: Routes.expenditureControl.expControlIndex,
      },
      {
        title: "Payment Schedule",
        route: Routes.expenditureControl.expControlScheduleIndex,
      },
      {
        title: "Payment Schedule Report Tracking",
        route: Routes.expenditureControl.paymentScheduleTracking,
      },
      {
        title: "Retention Report",
        route: Routes.expenditureControl.retentionReport,
      },
      {
        title: "Pending Retention",
        route: Routes.expenditureControl.pendingRetention,
      },
      {
        title: "Tax Report",
        route: Routes.expenditureControl.taxReport,
      },
      {
        title: "All PV Report Tracking",
        route: Routes.expenditureControl.allPvReportTracking,
      },
    ],
  },
  {
    title: "Dir. Exp. Control",
    section: "Expenditure Control",
    route: Routes.DashboardOverview,
    icon: faClipboardCheck,
    subMenu: [
      {
        title: "Review PVs",
        route: Routes.expenditureControl.dirExpFinalIndex,
      },
      {
        title: "Review Payment Schedule",
        route: Routes.expenditureControl.dirExpPaymentScheduleIndex,
      },
    ],
  },
  {
    title: "DAG",
    section: "Expenditure Control",
    route: Routes.DashboardOverview,
    icon: faUserShield,
    subMenu: [
      {
        title: "Approve PVs (MDAs)",
        route: Routes.dag.dagPendingPVIndex,
      },
    ],
  },
  {
    title: "Sub Treasury",
    section: "Sub-Treasury",
    route: Routes.DashboardOverview,
    icon: faMoneyBillWave,
    subMenu: [
      {
        title: "Receiving Office (ST)",
        route: Routes.subTreasury.receivingOfficeIndex,
      },
      {
        title: "Checking Office (ST)",
        route: Routes.subTreasury.checkingOfficeIndex,
      },
      {
        title: "Cash Office (RECURRENT)",
        route: Routes.subTreasury.recurrentCashOfficeIndex,
      },
      {
        title: "Cash Office (ALLIED)",
        route: Routes.subTreasury.alliedCashOfficeIndex,
      },
      {
        title: "Cash Office (EXPENDITURE))",
        route: Routes.subTreasury.expenditureCashOfficeIndex,
      },
      {
        title: "DST",
        route: Routes.subTreasury.dstOfficeIndex,
      },
      {
        title: "Review Payment (DST)",
        route: Routes.subTreasury.dstPendingScheduleOfficeIndex,
      },
      {
        title: "Sub Treasurer",
        route: Routes.subTreasury.subTreasurerPaymentReviewOfficeIndex,
      },
      {
        title: "Approved Payments",
        route: Routes.subTreasury.approvedPaymentsIndex,
      },
      {
        title: "Reports (ST)",
        route: Routes.subTreasury.reports,
      },
    ],
  },
  {
    title: "Remittance",
    section: "Sub-Treasury",
    route: Routes.DashboardOverview,
    icon: faPaperPlane,
    subMenu: [
      {
        title: "Remittance Slip",
        route: Routes.remittance.index,
      },
    ],
  },
  {
    title: "Reports",
    section: "Reports",
    route: Routes.DashboardOverview,
    icon: faChartBar,
    subMenu: [
      {
        title: "Budget Utilization Reports",
        route: Routes.budget.budgetUtlization,
      },
      {
        title: "Expenditure Reports",
        route: Routes.reports.expenditureReport,
      },
    ],
  },
  {
    title: "Revenue report",
    section: "Reports",
    route: Routes.DashboardOverview,
    icon: faChartLine,
    subMenu: [
      {
        title: "Revenue report",
        route: Routes.reports.revenueReport,
      },
      {
        title: "Revenue report by Admin",
        route: Routes.reports.revenueByAdmin,
      },
      {
        title: "Total Revenue by Economic",
        route: Routes.reports.totalRevenueByEconomic,
      },
      {
        title: "Capital Rec By Item",
        route: Routes.reports.capitalRecByItem,
      },
      {
        title: "Capital Revenue by Fund",
        route: Routes.reports.revenueByFund,
      },
      {
        title: "Revenue by MDA (New)",
        route: Routes.reports.revenueByMDA,
      },
    ],
  },
  {
    title: "Expenditure Report",
    section: "Reports",
    route: Routes.DashboardOverview,
    icon: faFileAlt,
    subMenu: [
      {
        title: "Expenditure report",
        route: Routes.reports.expenditureReport,
      },
      {
        title: "Expenditure by MDA",
        route: Routes.reports.expenditureByMDA,
      },
      {
        title: "Expenditure by Admin",
        route: Routes.reports.expenditureByAdmin,
      },
      {
        title: "Expenditure by Programme",
        route: Routes.reports.expenditureByProgramme,
      },
      {
        title: "Exp. by Location",
        route: Routes.reports.expByLocation,
      },
      {
        title: "Expenditure by Fund",
        route: Routes.reports.expenditureByFund,
      },
      {
        title: "Expenditure by Economic",
        route: Routes.reports.expenditureByEconomic,
      },
      {
        title: "Expenditure by Function",
        route: Routes.reports.expenditureByFunction,
      },
      {
        title: "Expenditure by Project",
        route: Routes.reports.expenditureByProject,
      },
    ],
  },
  {
    title: "Budget report",
    section: "Reports",
    route: Routes.DashboardOverview,
    icon: faBook,
    subMenu: [
      {
        title: "Approved Budget",
        route: Routes.reports.approvedBudget,
      },
      {
        title: "Budget Overview",
        route: Routes.reports.budgetPerformance,
      },
      {
        title: "Budget Performance",
        route: Routes.reports.budgetPerformanceFull,
      },
      {
        title: "MDA Budget Performance",
        route: Routes.reports.mdaBudgetPerformance,
      },
    ],
  },
  {
    title: "Accounts",
    section: "Administration",
    route: Routes.DashboardOverview,
    icon: faWallet,
    subMenu: [
      {
        title: "Manage Main Accounts",
        route: `${Routes.account.manageAccountMain}/MAIN ACCOUNT`,
      },
      {
        title: "Manage Sub Accounts",
        route: `${Routes.account.manageAccountMain}/SUB-TREASURY ACCOUNT`,
      },
      {
        title: "Manage Other Accounts",
        route: `${Routes.account.manageAccountMain}/OTHERS`,
      },
      {
        title: "Payment Reports",
        route: Routes.account.accountReport,
      },
    ],
  },
  {
    title: "Auditor Dashboard",
    section: "Administration",
    route: Routes.auditordashboard.auditorIndex,
    icon: faEye,
  },
  {
    title: "Admin",
    section: "Administration",
    route: Routes.DashboardOverview,
    icon: faUsersCog,
    subMenu: [
      { title: "MDA List", route: Routes.mdaList.index },
      {
        title: "Admin",
        route: Routes.userAdmin.index + "?role=admin",
      },
      { title: "Tax Setup", route: Routes.taxSetup.taxIndex },
    ],
  },
];
